var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-login"},[_c('div',{staticClass:"c-login__body"},[_c('forgot-password-email-form'),_c('ul',{staticClass:"c-login__list"},[_c('li',{staticClass:"c-login__item"},[_c('router-link',{staticClass:"c-login__link",attrs:{"to":"/"}},[_vm._v("Inloggen")])],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }